<script setup>
import { computed } from 'vue';

const props = defineProps({
  stage: { type: Object, required: true },
  // The stage's place on its pipeline, which picks a color for a stage that has none.
  index: { type: Number, default: 0 },
});

// Kept in a .vue file: Tailwind only scans templates and SFCs under custom/.
const PALETTE = {
  blue: 'bg-n-blue-3 text-n-blue-11',
  amber: 'bg-n-amber-3 text-n-amber-11',
  iris: 'bg-n-iris-3 text-n-iris-11',
  teal: 'bg-n-teal-3 text-n-teal-11',
};
const CYCLE = Object.keys(PALETTE);

// The seeded stages carry no color: they cycle through the palette by position.
const colorClass = computed(
  () =>
    PALETTE[props.stage.color] ||
    PALETTE[CYCLE[props.index % CYCLE.length]]
);
</script>

<template>
  <span
    class="inline-flex items-center h-6 px-2 text-xs font-medium rounded-md whitespace-nowrap"
    :class="colorClass"
  >
    {{ stage.name }}
  </span>
</template>
